var React = require('react');
var { connect } = require('react-redux');
var { withTranslation } = require('react-i18next');
var { useState, useEffect } = require('react');
const AccumulatedClickedIcon = require('images/icons/graph/blue_accumulated.svg');
const AccumulatedIcon = require('images/icons/graph/grey_accumulated.svg');
const GreyDropIcon = require('images/icons/graph/grey_drop.svg');
const BlueDropIcon = require('images/icons/graph/blue_drop.svg');
const BlueNitrogen = require('images/icons/graph/blue_nitrogen.svg');
const GreyNitrogen = require('images/icons/graph/nitrogen_grey.svg');
const TemperatureCelsiusSelected = require('images/icons/graph/temperature_celsius_selected.svg');
const TemperatureCelsiusUnselected = require('images/icons/graph/temperature_celsius_unselected.svg');
const TemperatureFahrenheitSelected = require('images/icons/graph/temperature_fahrenheit_selected.svg');
const TemperatureFahrenheitUnselected = require('images/icons/graph/temperature_fahrenheit_unselected.svg');

function GraphToggle({ initialValue, onToggleClick, icon, temperatureUnit }) {
  const [selectedButton, setSelectedButton] = useState(initialValue);

  DROP = 'drop';
  NITROGEN = 'nitrogen';
  ACCUMULATED = 'accumulated';
  TEMPERATURE = 'temperature';

  useEffect(() => {
    if (onToggleClick) {
      onToggleClick(selectedButton);
    }
  }, [selectedButton]);

  selectedStyle = {
    width: '36px',
    height: '26px',
    border: '0px',
    outline: 'none',
    backgroundColor: 'transparent',
  };
  nitrogenImage = selectedButton === NITROGEN ? BlueNitrogen : GreyNitrogen;
  dropImage = selectedButton === DROP ? BlueDropIcon : GreyDropIcon;
  waterMeterImage =
    selectedButton === ACCUMULATED ? AccumulatedClickedIcon : AccumulatedIcon;

  // Temperature icon based on user's temperature unit preference
  const isFahrenheit =
    (temperatureUnit || 'celsius').toLowerCase() === 'fahrenheit';
  const isTemperatureSelected = selectedButton === TEMPERATURE;
  let temperatureImage;
  if (isFahrenheit) {
    temperatureImage = isTemperatureSelected
      ? TemperatureFahrenheitSelected
      : TemperatureFahrenheitUnselected;
  } else {
    temperatureImage = isTemperatureSelected
      ? TemperatureCelsiusSelected
      : TemperatureCelsiusUnselected;
  }

  return (
    <div
      className='d-flex d-inline align-items-end position-relative'
      style={{ height: '32px', marginBottom: '-3px' }}
    >
      {icon.includes('drop') && (
        <button
          className=''
          style={selectedStyle}
          onClick={() => {
            if (selectedButton !== DROP) {
              setSelectedButton(DROP);
            }
          }}
        >
          <div className='icon-toggle-container'>
            <img src={dropImage} />{' '}
          </div>
          <div
            style={{
              width: '24px',
              height: '3px',
              backgroundColor: '#4563C7',
              alignSelf: 'stretch',
              visibility: selectedButton !== DROP ? 'hidden' : true,
            }}
          />
        </button>
      )}
      {icon.includes('nitrogen') && (
        <button
          className=''
          style={selectedStyle}
          onClick={() => {
            if (selectedButton !== NITROGEN) {
              setSelectedButton(NITROGEN);
            }
          }}
        >
          <div className='icon-toggle-container'>
            <img src={nitrogenImage} />{' '}
          </div>
          <div
            style={{
              width: '24px',
              height: '3px',
              backgroundColor: '#4563C7',
              alignSelf: 'stretch',
              visibility: selectedButton !== NITROGEN ? 'hidden' : true,
            }}
          />
        </button>
      )}
      {icon.includes('accumulated') && (
        <button
          className=''
          style={selectedStyle}
          onClick={() => {
            if (selectedButton !== ACCUMULATED) {
              setSelectedButton(ACCUMULATED);
            }
          }}
        >
          <div className='icon-toggle-container'>
            <img src={waterMeterImage} />{' '}
          </div>
          <div
            style={{
              width: '24px',
              height: '3px',
              backgroundColor: '#4563C7',
              alignSelf: 'stretch',
              visibility: selectedButton !== ACCUMULATED ? 'hidden' : true,
            }}
          />
        </button>
      )}
      {icon.includes('temperature') && (
        <button
          className=''
          style={selectedStyle}
          onClick={() => {
            if (selectedButton !== TEMPERATURE) {
              setSelectedButton(TEMPERATURE);
            }
          }}
        >
          <div className='icon-toggle-container'>
            <img src={temperatureImage} />{' '}
          </div>
          <div
            style={{
              width: '24px',
              height: '3px',
              backgroundColor: '#4563C7',
              alignSelf: 'stretch',
              visibility: selectedButton !== TEMPERATURE ? 'hidden' : true,
            }}
          />
        </button>
      )}
    </div>
  );
}

module.exports = connect()(withTranslation()(GraphToggle));
